// extracted by extract-css-chunks-webpack-plugin
module.exports = {"ol":"HjyKnM","ul":"_37LeZT"};